import * as React from 'react';
import PropTypes from 'prop-types';
import Paragraph from '../images/paragraph.png';
import ParagraphShort from '../images/short-paragraph.png';

const toArray = value => {
	value = Math.max(1, value);
	let back = [];
	for(let i = 0; i < value; ++i) {
		back.push(true);
	}
	return back;
};

const Placeholder = ({style, repeat, short, alt, margin, holderStyle, ...props}) => (
	<div style={style}>
		{toArray(repeat).map((_, index) => <img key={`placeholder-${index}`} src={short ? ParagraphShort : Paragraph} alt={alt} style={{display: 'block', marginBottom: Math.max(0, margin), ...holderStyle}} {...props} />)}
	</div>
);

Placeholder.propTypes = {
	repeat: PropTypes.number,
	short: PropTypes.bool,
	alt: PropTypes.string,
	margin: PropTypes.number,
	holderStyle: PropTypes.object,
	style: PropTypes.object
};

Placeholder.defaultProps = {
	repeat: 1,
	short: false,
	alt: 'Platzhalter',
	margin: 15,
	holderStyle: {},
	style: {}
};


const _extend = (Component) =>
	class extends React.PureComponent {
		render() {
			const {children, as, visible, ...props} = this.props;
			if (visible) {
				return <Component {...props}/>;
			}
			const Tag = as;
			return (
				<Tag>
					{children}
				</Tag>
			);
		}
	};

export const ExtendedPlaceholder = _extend(Placeholder);

ExtendedPlaceholder.propTypes = {
	repeat: PropTypes.number,
	short: PropTypes.bool,
	alt: PropTypes.string,
	margin: PropTypes.number,
	holderStyle: PropTypes.object,
	style: PropTypes.object,
	children: PropTypes.node,
	as: PropTypes.any,
	visible: PropTypes.bool
};

ExtendedPlaceholder.defaultProps = {
	repeat: 1,
	short: false,
	alt: 'Platzhalter',
	margin: 15,
	holderStyle: {},
	style: {},
	as: React.Fragment,
	visible: false
};



export default Placeholder;


// WEBPACK FOOTER //
// ./src/components/Placeholder.js